export const CUSTOMER_GROUPS = {
  tradeAlly: "Trade Ally",
  general: "General",
  contractor: "Contractor"
};
export const COORDINATES_FIELD = ["address"];
export const HOME_DETAILS_SQFT = ["homeSquareFeet"];
export const DATE_TIME_FORMAT = "h:mm a";
export const SHORT_DATE_FORMAT = "dddd, MMMM Do";
export const SUBTITLE_TEXT_SCHEDULE = "Please select your preferred appointment time. The Energy Advisor may arrive up to 30 minutes before or after the scheduled start time for in-home assessments.";
export const SUBTITLE_TEXT_SUMMARY = "The Energy Advisor may arrive up to 30 minutes before or after the scheduled start time for in-home assessments.";
export const CANCEL_REASONS = [
  {
    "id": "unableToGetTimeOff",
    "name": "unableToGetTimeOff",
    "label": "Unable to get time off",
    "scope": "none",
    "group": "none",
    "position": 0,
    "required": true,
    "field": {
      "type": "checkbox",
      "showOnSummary": false
    }
  },
  {
    "id": "forgotAboutAppointment",
    "name": "Forgot about appointment",
    "label": "Forgot about appointmentThird Party Policies",
    "scope": "none",
    "required": true,
    "group": "none",
    "position": 1,
    "field": {
      "type": "checkbox",
      "showOnSummary": false
    }
  },
  {
    "id": "forgotAboutAppointment2",
    "name": "Forgot about appointment",
    "label": "Forgot about appointmentThird Party Policies",
    "scope": "none",
    "required": true,
    "group": "none",
    "position": 2,
    "content": '<div class="MuiInputBase-root MuiInput-root MuiInputBase-fullWidth MuiInput-fullWidth MuiInputBase-formControl MuiInput-formControl"><input aria-invalid="false" id="firstName" name="firstName" placeholder="Ex. John" type="text" class="MuiInputBase-input MuiInput-input" value="PEDRO"></div>',
    "field": {
      "type": "checkbox",
      "showOnSummary": false
    }
  },
];
export const DEFAULT_REBATE_MESSAGE = `
<strong>Your Rebate value displays $0.00 because model number information was not entered or the
equipment information you entered does not exactly match the qualified equipment in our system.</strong>
</br></br>
<ul>
  <li>AFTER you submit, your application will be fully reviewed by our staff for eligibility.</li>
  <li>Please complete and submit the application. We will contact you to inform of your rebate
  status or to request additional information.</li>
</ul>`;


export const LANGUAGE_TEXT = {
  es_EN: {
    ahri_auto_fill : "Enter AHRI Number, to autofill product info below.",
    terms_and_condition: "I have read, understood and agree to the",
    back_button_text: "Back",
    next_button_text: "Next",
    expand_terms_and_condition: "Please expand and read the program Terms and Conditions before confirming your acceptance",
    schedule_appointment_text: "Schedule your appointment",
    appointment_filter_text: "Filter appointments by start time:",
    anytime: "Anytime",
    morning: "Morning",
    afternoon: "Afternoon",
    available_times: "Available Times",
    appointment_type: "Appointment Type",
    appointment_date: "Appointment Date",
    start_time: "Start Time",
    estimated_appointment_time: "Estimated Appointment Time",
    savings_text: "Your Savings",
    complete_text:"complete"
  },
  es_ES: {
    ahri_auto_fill : "Ingrese el número AHRI para autocompletar la información del producto a continuación.",
    terms_and_condition: "He leído, comprendido y acepto las",
    back_button_text: "Atrás",
    next_button_text: "próximo",
    expand_terms_and_condition: "Por favor amplíe y lea los Términos y condiciones del programa antes de confirmar su aceptación.",
    schedule_appointment_text: "Agenda tu cita",
    appointment_filter_text: "Filtrar citas por hora de inicio:",
    anytime: "En cualquier momento",
    morning: "Mañana",
    afternoon: "Tarde",
    available_times: "Horarios disponibles",
    appointment_type: "Tipo de cita",
    appointment_date: "Fecha de cita",
    start_time: "Hora de inicio",
    estimated_appointment_time: "Hora estimada de la cita",
    savings_text: "Tus ahorros",
    complete_text:"completa"
  }
};
